import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';

import { urlEndPoints } from '../config/end-points';
import { Motif } from '../models/motif.model';

@Injectable({
  providedIn: 'root',
})
export class MotifDal {
  constructor(private httpClient: HttpClient) {}

  getAllMotifs(dataType?: string): Observable<Motif[]> {
    const params = dataType ? new HttpParams().set('dataType', dataType) : undefined;
    return this.httpClient.get<Motif[]>(urlEndPoints.motifs, { params });
  }
}
